import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import {
  SessionPublicAPIsForStartFlowApi,
  VerifyOtpRequest,
} from "../../orchestrator-api-client";
import NavigationMapper from "../../constants/navigation-mapper.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const verifyOtp = createAsyncThunk<void, VerifyOtpRequest, ThunkApi>(
  "layout/submitOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await new SessionPublicAPIsForStartFlowApi().verifyOtp(
        data,
      );
      const redirectUrlForInterruptedKyc = response.headers["location"];
      if (redirectUrlForInterruptedKyc) {
        // EDGE CASE: Namirial KYC interrupted, redirect from BE with location headers
        window.location.href = redirectUrlForInterruptedKyc;
      } else {
        // DEFAULT CASE: redirect from BE based on state and workflowId
        const { workflowId, state } = response.data;
        if (state) {
          window.location.href = `${NavigationMapper[state]}?id=${workflowId}`;
        }
      }
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Codice OTP",
        description: "Otp non valido",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
